const iconIdBase64 = {};
export default iconIdBase64;
